<template>
    <div>
        <v-list dense nav >
        <v-list-item :to="{ name: 'pos.compra.factura' }" class="hoverable">
          <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Facturas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item :to="{ name: 'pos.comprasPedidoListado' }"  class="hoverable">
          <v-list-item-icon><v-icon>mdi-clipboard-list</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item :to="{ name: 'pos.comprasRemitoListado' }" class="hoverable">
          <v-list-item-icon><v-icon>mdi-truck-delivery-outline</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Remitos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
</template>

<script>
    export default {
        name: 'ComprasEmpresaListado',
    }
</script>

<style lang="scss" scoped>

</style>